/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import { KTSVG } from '../../../../helpers'
import { getGuidances } from '../../../../../app/modules/guidance/guidances-list/core/_requests'
import { PublishingOptionModel, RoleModel, useAuth } from '../../../../../app/modules/auth'
import { Guidance, initialGuidances } from '../../../../../app/modules/guidance/guidances-list/core/_models'
import { useIntl } from "react-intl";
import { useNavigate } from 'react-router-dom'
import { useYear } from '../../../../../_metronic/partials/layout/header-menus/YearsManager'
import { useTerm } from '../../../../../_metronic/partials/layout/header-menus/TermsManager'

type Props = {
  className: string
}

const MessageTableWidget: React.FC<Props> = ({ className }) => {
  const intl = useIntl();
  const { currentUser, auth } = useAuth()
  const [guidances, setGuidances] = useState<Guidance[]>(initialGuidances)
  const navigate = useNavigate();
  const currentYearId = useYear()
  const currentTermId = useTerm()

  useEffect(() => {
    if (auth!.currentRole === RoleModel.Person)
      getGuidances("&personId=" + currentUser?.personId + '&academicYearId=' + currentYearId + '&termId=' + currentTermId).then((values) => { setGuidances(values.data!) })
    else if (auth!.currentRole === RoleModel.Customer)
      getGuidances("&customerId=" + currentUser?.customerId + '&academicYearId=' + currentYearId + '&termId=' + currentTermId + '&publishingOptionId=' + PublishingOptionModel.Evaluation).then((values) => { setGuidances(values.data!) })
    else if (auth!.currentRole === RoleModel.Employee)
      getGuidances("&employeeId=" + currentUser?.employeeId + '&academicYearId=' + currentYearId + '&termId=' + currentTermId).then((values) => { setGuidances(values.data!) })
  }, [])

  const openTakeCoursePage = (
    guidanceId: number,
    courseId: number,
    customerId: number | undefined,
    personId: number | undefined,
    employeeId: number | undefined) => {
    if (auth!.currentRole === RoleModel.Customer)
      navigate({ pathname: '/crafted/courses/takecourse/takecourse', search: '?courseId=' + courseId + '&customerId=' + customerId + '&guidanceId=' + guidanceId })
    else if (auth!.currentRole === RoleModel.Person)
      navigate({ pathname: '/crafted/courses/takecourse/takecourse', search: '?courseId=' + courseId + '&personId=' + personId + '&guidanceId=' + guidanceId + '&customerId=' + customerId })
    else if (auth!.currentRole === RoleModel.Employee)
      navigate({ pathname: '/crafted/courses/takecourse/takecourse', search: '?courseId=' + courseId + '&employeeId=' + employeeId + '&guidanceId=' + guidanceId })
  }

  return (
    <>
      {guidances.filter(x => !x.courseResultTypeId && !x.guidanceResultTypeId && x.publishingOptionId !== PublishingOptionModel.Conversation) &&
        guidances.filter(x => !x.courseResultTypeId && !x.guidanceResultTypeId && x.publishingOptionId !== PublishingOptionModel.Conversation).length > 0 &&

        <div className={`card ${className}`}>
          {/* begin::Header */}
          <div className='card-header bg-primary border-0 pt-5'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label text-white fw-bold fs-3 mb-1'>{intl.formatMessage({ id: 'o9a' })}</span>
              <span className='text-white fw-semibold fs-7'>{intl.formatMessage({ id: '6zz' })}</span>
            </h3>

          </div>
          {/* end::Header */}
          {/* begin::Body */}
          <div className='card-body py-3'>
            {/* begin::Table container */}
            <div className='table-responsive'>
              {/* begin::Table */}
              <table className='table align-middle gs-0 gy-5'>
                {/* begin::Table head */}
                <thead>
                  <tr>
                    <th className='p-0 min-w-360px'></th>
                    <th className='p-0 min-w-40px'></th>
                  </tr>
                </thead>
                {/* end::Table head */}
                {/* begin::Table body */}
                <tbody>
                  {
                    guidances.filter(x => !x.courseResultTypeId && !x.guidanceResultTypeId && x.publishingOptionId !== PublishingOptionModel.Conversation).map(guidance =>
                    (<tr key={guidance?.id}>
                      <td>
                        <a onClick={() => openTakeCoursePage(Number(guidance?.id), Number(guidance?.courseId), guidance?.customerId, guidance?.personId, guidance?.employeeId)} className='text-dark fw-bold text-hover-primary mb-1 fs-6'>
                          <span className="badge badge-primary">{guidance.courseName}</span>
                        </a>
                        <span className='badge badge-secondary'>{guidance?.personId ? guidance?.personName + '->' : <></>}{guidance?.customerName}</span>
                        <br></br>
                        <span className='badge badge-secondary'>{new Date(guidance?.startDate!).toLocaleDateString()}</span>-
                        <span className='badge badge-secondary'>{new Date(guidance?.endDate!).toLocaleDateString()}</span>
                      </td>
                      <td className='text-end'>
                        <a onClick={() => openTakeCoursePage(Number(guidance?.id), Number(guidance?.courseId), guidance?.customerId, guidance?.personId, guidance?.employeeId)} className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'>
                          <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-2' />
                        </a>
                      </td>
                    </tr>
                    ))
                  }
                </tbody>
                {/* end::Table body */}
              </table>
              {/* end::Table */}
            </div>
            {/* end::Table container */}
          </div>
        </div>
      }
    </>
  )
}

export { MessageTableWidget }
